import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import CloseIcon from "@mui/icons-material/Close";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import Swal from "sweetalert2";
import {
  getDepartments,
  getCitiesByDepartment,
} from "../services/get-departments-city";
import axios from "axios";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const proxyBase = process.env.REACT_APP_FUNCTION_CONSUME_LOGS_GOOGLEMAPS; // tu API

const geocodeAddressModal = async (address, city = "", state = "") => {
  if (!address) throw new Error("Address is required.");

  try {
    const response = await axios.get(proxyBase, {
      params: {
        address,
        city,
        state,
        country: "CO",
        endpointType: "geocode",
      },
    });

    const payload = response.data;
    const googleData = payload.data;

    if (googleData.status === "OK" && googleData.results[0]) {
      return googleData.results[0].geometry.location;
    }

    // Fallback con city/state
    const fallbackResp = await axios.get(proxyBase, {
      params: {
        address: `${city}, ${state}`,
        country: "CO",
        endpointType: "geocode",
      },
    });

    const fallbackPayload = fallbackResp.data;
    const fallbackData = fallbackPayload.data;

    if (fallbackData.status === "OK" && fallbackData.results[0]) {
      return fallbackData.results[0].geometry.location;
    }

    throw new Error(
      "Error fetching location. Status: " +
        fallbackData.status
    );
  } catch (err) {
    console.error("Error in geocoding:", err.message);
    throw err;
  }
};

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "15px",
};

const MapModal = ({
  address,
  onClose,
  city,
  street,
  state,
  shippingId,
  setNewLocation,
  compliment,
}) => {
  const [departamentos, setDepartamentos] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [departamento, setDepartamento] = useState(state || "");
  const [ciudad, setCiudad] = useState(city || "");
  const [complemento, setComplemento] = useState(compliment || "");
  const [direccion, setDireccion] = useState(street || "");
  const [latitud, setLatitud] = useState("");
  const [longitud, setLongitud] = useState("");
  const [centerModal, setCenterModal] = React.useState({
    lat: 4.570868,
    lng: -74.297333,
  });

  useEffect(() => {
    // Carga inicial de departamentos
    const loadDepartments = async () => {
      const departmentsData = await getDepartments();
      setDepartamentos(departmentsData); // Corregido para usar el estado adecuado
    };

    loadDepartments();
  }, []);

  useEffect(() => {
  const loadCities = async () => {
    if (!departamento) {
      setCiudades([]);
      return;
    }

    try {
      const citiesData = await getCitiesByDepartment(departamento);
      setCiudades(citiesData);
    } catch (error) {
      console.error("Error al cargar las ciudades:", error);
      setCiudades([]);
    }
  };

  loadCities();
}, [departamento]);


  useEffect(() => {
    const geocodeAndUpdateMapWithDefaultCity = async () => {
      if (departamento && ciudades.length > 0 && direccion) {
        try {
          // Utiliza la primera ciudad de la lista como la nueva ciudad por defecto
          const combinedAddress = `${direccion}, ${ciudades[0]}, ${departamento}`;
          const location = await geocodeAddressModal(
            combinedAddress,
            ciudades[0],
            departamento,
            apiKey
          );
          setCenterModal(location); // Actualiza la ubicación central del mapa
          setLatitud(location.lat); // Actualiza el input de latitud
          setLongitud(location.lng); // Actualiza el input de longitud
        } catch (error) {
          console.error(error);
        }
      }
    };

    geocodeAndUpdateMapWithDefaultCity();
  }, [departamento, ciudades, direccion, apiKey]);

  useEffect(() => {
    const geocodeAndUpdateMap = async () => {
      if (departamento && ciudad && direccion) {
        try {
          // Combina la dirección, ciudad y departamento para la geolocalización
          const combinedAddress = `${direccion}, ${ciudad}, ${departamento}`;
          const location = await geocodeAddressModal(
            combinedAddress,
            ciudad,
            departamento,
            apiKey
          );
          setCenterModal(location); // Actualiza la ubicación central del mapa
          setLatitud(location.lat); // Actualiza el input de latitud
          setLongitud(location.lng); // Actualiza el input de longitud
        } catch (error) {
          console.error(error);
        }
      }
    };

    geocodeAndUpdateMap();
  }, [departamento, ciudad, direccion, apiKey]);

  const reverseGeocode = async (lat, lng) => {
  try {
    // Llamada a tu API personalizada
    const response = await axios.get(proxyBase, {
      params: {
        lat, // latitud
        lng, // longitud
        endpointType: "geocode" // Tipo de consulta
      }
    });

    // Si la API de tu servidor devuelve datos, lo extraemos
    const payload = response.data;
    const googleData = payload.data;

    if (googleData.status === "OK" && googleData.results[0]) {
      const addressComponents = googleData.results[0].address_components;

      let streetNumber = "";
      let route = "";
      let locality = "";
      let administrativeArea = "";

      addressComponents.forEach((component) => {
        if (component.types.includes("street_number")) {
          streetNumber = component.long_name;
        }
        if (component.types.includes("route")) {
          route = component.long_name;
        }
        if (component.types.includes("locality")) {
          locality = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          administrativeArea = component.long_name;
        }
        // Aquí puedes continuar añadiendo otros componentes si es necesario
      });

      const address = `${streetNumber} ${route}`;
      const city = locality;
      const state = administrativeArea;

      return { address, city, state };
    } else {
      throw new Error("No se pudo obtener la dirección desde la ubicación.");
    }
  } catch (error) {
    console.error("Error en la geocodificación inversa", error);
    throw error;
  }
};


  const handleSave = async () => {
    const newLocation = {
      departamento,
      ciudad,
      direccion,
      complemento,
    };
    // Aquí pasarías la nueva ubicación hacia arriba para ser usada por otro componente o función
    await setNewLocation(newLocation);
    onClose(); // Cerrar el modal después de guardar
    Swal.fire({
      icon: "success",
      title: "¡Ubicación Actualizada!",
      text: `La ubicación del envío ${shippingId} ha sido cambiada correctamente.`,
    });
  };

  const handleDepartmentChange = (event) => {
    const selectedDepartment = event.target.value;
    setDepartamento(selectedDepartment);
    setCiudad(""); // Limpia la ciudad al cambiar de departamento
  };

 const handleCityChange = (event) => {
  const selectedCity = event.target.value;
  setCiudad(selectedCity);
};


  const updateLocation = async (lat, lng) => {
    setLatitud(lat);
    setLongitud(lng);

    // Aquí asumimos que tienes una función que puede hacer geocodificación inversa a partir de la lat y lng
    try {
      const addressData = await reverseGeocode(lat, lng, apiKey);
      setDireccion(addressData.address);
      setCiudad(addressData.city);
      setDepartamento(addressData.state);
      setCenterModal({ lat, lng });
    } catch (error) {
      console.error(error);
    }
  };

  const mapOptions = {
    streetViewControl: false, // Desactiva el control de Street View
    scaleControl: false, // Desactiva el control de escala
    mapTypeControl: false, // Desactiva el control para cambiar el tipo de mapa
    panControl: false, // Desactiva el control de paneo
    zoomControl: false, // Desactiva los controles de zoom
    fullscreenControl: false, // Desactiva el botón de pantalla completa
  };

  useEffect(() => {
    const fetchLocation = async () => {
      if (address) {
        try {
          const location = await geocodeAddressModal(
            address,
            city,
            state,
            apiKey
          );
          setCenterModal(location);
          setLatitud(location.lat);
          setLongitud(location.lng);
        } catch (error) {
          console.error(error);
        }
      }
    };
    

    fetchLocation();
  }, [address, city, state, apiKey]);
  useEffect(() => {
  if (departamento && !ciudades.length) {
    getCitiesByDepartment(departamento).then(setCiudades);
  }
}, [departamento]);

  return (
    <div className="map-modal">
      <div className="map-modal-content">
        <div className="map-modal-header">
          <span className="map-modal-title">Modificar Ubicación</span>
          <span className="map-modal-shipment-id">{shippingId}</span>
        </div>
        <button className="map-modal-close-button" onClick={onClose}>
          <CloseIcon className="close-icon" />
        </button>
        <LoadScript googleMapsApiKey={apiKey}>
          <GoogleMap
            mapContainerStyle={{ ...containerStyle, maxHeight: "70%" }}
            center={centerModal}
            zoom={17}
            options={mapOptions}
            className="map-content"
          >
            <Marker
              position={centerModal}
              draggable={true}
              onDragEnd={(e) => {
                updateLocation(e.latLng.lat(), e.latLng.lng());
              }}
            />
          </GoogleMap>
          <div className="map-modal-footer">
            <select
              title="Departamento"
              value={departamento}
              onChange={(e) => {
                setDepartamento(e.target.value); // Guarda el id del departamento
                setCiudad(""); // Limpia la ciudad cuando se cambia de departamento
              }}
            >
              <option value="">Seleccione un departamento</option>
              {departamentos.map((dep) => (
                <option key={dep.id} value={dep.id}>
                  {dep.name}
                </option>
              ))}
            </select>

            {/* Select de Ciudad */}
            <select
              title="Ciudad"
              value={ciudad}
              onChange={(e) => setCiudad(e.target.value)}
              disabled={!departamento}
            >
              <option value="">Seleccione una ciudad</option>
              {ciudades.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>

            <input
              type="text"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
              className="direccion-input"
            />
            <input
              type="text"
              value={latitud}
              onChange={(e) => setLatitud(e.target.value)}
              className="latitud-input"
            />
            <input
              type="text"
              value={longitud}
              onChange={(e) => setLongitud(e.target.value)}
              className="longitud-input"
            />
            <button onClick={handleSave}>
              <SaveAsIcon className="save-icon" />
            </button>
          </div>

          <div className="complemento-container">
            <input
              type="text"
              value={complemento}
              onChange={(e) => setComplemento(e.target.value)}
              placeholder="Complemento"
              className="complemento-input"
            />
          </div>
        </LoadScript>
      </div>
    </div>
  );
};

export default MapModal;
